function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudMigration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Server--inject-215"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429,249.89a66.47,66.47,0,0,0-35.43-54.63,66.45,66.45,0,0,0-109.81-72.13,66.47,66.47,0,0,0-125.87,41.61c-2-.19-4.11-.3-6.2-.3A66.46,66.46,0,0,0,88,249.89Z",
    style: {
      fill: "#DDEFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,249.89H429c-.14-2.17-.38-4.32-.72-6.42H86.43A66,66,0,0,0,88,249.89Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.9,141.82l2.41-1.1-.51-2.89-2.66-.21a11.06,11.06,0,0,0-1.34-2.52l1.38-2.32-2.08-2.08-2.34,1.39a11.47,11.47,0,0,0-4.46-1.82l-.67-2.67h-2.94l-.68,2.68a11.87,11.87,0,0,0-2.65.84l-2.1-1.82L175.85,131l1,2.6a12.42,12.42,0,0,0-1.69,2.19l-2.76-.28-1,2.76,2.29,1.56a12.41,12.41,0,0,0-.16,2c0,.28,0,.55,0,.83l-2.41,1.34.76,2.84,2.73,0a11.25,11.25,0,0,0,1.5,2.38l-1.18,2.45,2.25,1.89,2.19-1.56A11.54,11.54,0,0,0,182,153l.43,2.63,2.93.26.89-2.49a12,12,0,0,0,2.82-.61l1.85,1.87,2.54-1.47-.7-2.53a11.64,11.64,0,0,0,2-2.13l2.59.47,1.24-2.66-2-1.68A11.67,11.67,0,0,0,196.9,141.82Zm-4.35,0a7.35,7.35,0,1,1-7.35-7.34A7.34,7.34,0,0,1,192.55,141.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "86.87 219.38 140.19 219.38 148.79 227.98 423.58 227.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "282.96 243.9 282.96 138.97 345.32 138.97 345.32 102.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.8,116.51l1.48-.67-.31-1.77-1.63-.13a7.3,7.3,0,0,0-.81-1.54l.83-1.42-1.27-1.27-1.42.85a7.13,7.13,0,0,0-2.73-1.11l-.41-1.63h-1.8l-.42,1.64a7.37,7.37,0,0,0-1.61.51l-1.29-1.11-1.47,1,.61,1.59a6.78,6.78,0,0,0-1,1.34l-1.69-.17-.61,1.69,1.4,1a6.59,6.59,0,0,0-.1,1.19,4.1,4.1,0,0,0,0,.5l-1.48.83.47,1.73,1.67,0a6.63,6.63,0,0,0,.91,1.46l-.72,1.5,1.38,1.15,1.33-.95a7.14,7.14,0,0,0,1.61.68L240,125l1.79.15.54-1.52a6.93,6.93,0,0,0,1.72-.37l1.13,1.14,1.56-.89-.43-1.55a7.1,7.1,0,0,0,1.2-1.31l1.58.29.76-1.63-1.24-1A7.23,7.23,0,0,0,248.8,116.51Zm-2.66,0a4.49,4.49,0,1,1-4.48-4.49A4.48,4.48,0,0,1,246.14,116.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.57,136.79l1.48-.67-.31-1.77-1.63-.13a6.69,6.69,0,0,0-.82-1.54l.84-1.42L269.86,130l-1.43.85a7,7,0,0,0-2.72-1.12l-.41-1.63h-1.8l-.42,1.64a7.39,7.39,0,0,0-1.61.52l-1.29-1.11-1.47,1,.61,1.59a6.78,6.78,0,0,0-1,1.34l-1.69-.18-.61,1.69,1.4.95a6.78,6.78,0,0,0-.1,1.2,4.18,4.18,0,0,0,0,.5l-1.48.83.47,1.73,1.67,0a7.13,7.13,0,0,0,.91,1.46l-.72,1.49,1.38,1.16,1.33-1a7,7,0,0,0,1.61.68l.27,1.61,1.79.16.54-1.52a7.42,7.42,0,0,0,1.72-.38l1.13,1.15,1.56-.9-.43-1.55a7,7,0,0,0,1.2-1.3l1.58.29.76-1.63-1.24-1A7.23,7.23,0,0,0,271.57,136.79Zm-2.66,0a4.49,4.49,0,1,1-4.49-4.49A4.49,4.49,0,0,1,268.91,136.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.12,
    cy: 209.06,
    r: 6.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.12,
    cy: 209.06,
    r: 4.73,
    style: {
      fill: "#DDEFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.32,
    y: 194.73,
    width: 48.16,
    height: 23.65,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.12,
    y: 145.71,
    width: 48.16,
    height: 98.05,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335 234.72 223.29 234.72 234.47 169.07 323.82 169.07 335 234.72",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.81,
    y: 172.37,
    width: 11.18,
    height: 8.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.43,
    y: 172.37,
    width: 11.18,
    height: 8.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.12,
    y: 172.37,
    width: 27.52,
    height: 8.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.26,
    y: 178.11,
    width: 129.76,
    height: 65.65,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.75,
    y: 183.98,
    width: 1.72,
    height: 17.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.77,
    y: 183.98,
    width: 1.72,
    height: 17.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.79,
    y: 183.98,
    width: 1.72,
    height: 17.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.95,
    y: 183.98,
    width: 1.72,
    height: 17.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.98,
    y: 183.98,
    width: 1.72,
    height: 17.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 183.98,
    width: 1.72,
    height: 17.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.26,
    y: 199.03,
    width: 129.76,
    height: 15.05,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.47,
    y: 201.61,
    width: 3.87,
    height: 3.87,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.86,
    y: 201.61,
    width: 3.87,
    height: 3.87,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.24,
    y: 201.61,
    width: 3.87,
    height: 3.87,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.47,
    y: 207.85,
    width: 3.87,
    height: 3.87,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.86,
    y: 207.85,
    width: 3.87,
    height: 3.87,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.24,
    y: 207.85,
    width: 3.87,
    height: 3.87,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.13,
    y: 215.59,
    width: 3.87,
    height: 3.87,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.51,
    y: 215.59,
    width: 3.87,
    height: 3.87,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.9,
    y: 215.59,
    width: 3.87,
    height: 3.87,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.73,
    y: 207.85,
    width: 3.87,
    height: 3.87,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.11,
    y: 207.85,
    width: 3.87,
    height: 3.87,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.5,
    y: 207.85,
    width: 3.87,
    height: 3.87,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.26,
    y: 214.08,
    width: 129.76,
    height: 6.02,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.85,175.81a2.15,2.15,0,1,1-2.15-2.15A2.15,2.15,0,0,1,206.85,175.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.23,151.81a2.15,2.15,0,1,1-2.15-2.15A2.15,2.15,0,0,1,191.23,151.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.85,151.81a2.15,2.15,0,1,1-2.15-2.15A2.16,2.16,0,0,1,206.85,151.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.85,187.85a2.15,2.15,0,1,1-2.15-2.15A2.15,2.15,0,0,1,206.85,187.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.85,199.89a2.15,2.15,0,1,1-2.15-2.15A2.15,2.15,0,0,1,206.85,199.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.93,187.85a6,6,0,1,0-6,6A6,6,0,0,0,230.93,187.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.64,187.85a4.73,4.73,0,1,0-4.73,4.73A4.73,4.73,0,0,0,229.64,187.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.38,198.17a6,6,0,1,0-6,6A6,6,0,0,0,197.38,198.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.09,198.17a4.73,4.73,0,1,0-4.73,4.73A4.73,4.73,0,0,0,196.09,198.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "209 211.5 173.73 211.5 173.73 241.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "207.71 157.75 185.77 157.75 176.96 148.93 164.27 148.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.1,
    y1: 185.27,
    x2: 290.27,
    y2: 185.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.1,
    y1: 188.71,
    x2: 290.27,
    y2: 188.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.1,
    y1: 192.15,
    x2: 290.27,
    y2: 192.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--charater-4--inject-215"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.67,156.15a3.86,3.86,0,0,0-4.26,1.73c-1.58,2.52.16,8.67.79,10.25s3.15.63,3.15.63l.79,2,2.21-.31v-2.84a16.53,16.53,0,0,0,1.26-7.25C370.29,156.62,367.61,156.15,366.67,156.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.37 183.98 355.07 184.29 367.76 185.84 366.37 183.98",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.57,210.05s-.51,11.6-.83,16.17-.47,15.13-.47,15.13h1.26l2.52-19.54,1.46-11.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.77 209.89 370.1 227.17 376.71 241.35 377.98 241.35 372.77 226.38 372.34 210.05 367.77 209.89",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.27 241.35 357.96 244.98 362.53 243.25 362.53 241.35 361.27 241.35",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.71 241.35 373.4 244.98 377.98 243.25 377.98 241.35 376.71 241.35",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.14,170.8s-3.63,7.25-3.63,8.2,2.68,6.15,2.68,6.15l-4.74,32.61h12.92l-1.08-17.17a24.76,24.76,0,0,0-.48-9.3c-1.26-4.09-2.36-6.93-2.36-6.93l1.57-6.94-2.67-6.93Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.61,160.4c-.32-3.78-3-4.25-3.94-4.25a3.86,3.86,0,0,0-4.26,1.73,4,4,0,0,0-.42,1,2.32,2.32,0,0,1,3.1.25c1.73,1.73,0,2.84.79,3.78s2.68.16,2.36,1.74a2.47,2.47,0,0,0,1.13,2.93A16.42,16.42,0,0,0,370.61,160.4Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.44,161a3,3,0,1,1-3-3A3,3,0,0,1,376.44,161Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.27 180.27 357.08 191.72 358.17 191.1 351.36 179.5 350.27 180.27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.66,174.59a1.48,1.48,0,0,0-2.05,1.26c-.31,1.89-1.57,10.4-1.57,10.4H353.27l1.26,1.1,13.55,1.58,2.37-11A2.34,2.34,0,0,0,369.66,174.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-215"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.25,
    y: 191.91,
    width: 3.49,
    height: 5.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.57,
    y: 189.19,
    width: 1.41,
    height: 2.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.83,
    y: 189.19,
    width: 1.41,
    height: 2.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.76,
    y: 184.63,
    width: 6.27,
    height: 11.02,
    rx: 3.13,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300 220.99 294.67 221.66 296.33 242.99 297.83 242.99 298.33 226.82 302 226.53 300 220.99",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317 220.99 322.33 221.66 320.67 242.99 319.17 242.99 318.67 226.82 315 226.53 317 220.99",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.5 196.53 320 196.53 314.75 226.53 302 226.53 297.5 196.53",
    style: {
      fill: "#DDEFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.5 196.53 291.38 207.53 289.13 203.28 287.75 203.66 290.63 212.28 298.5 204.66 297.5 196.53",
    style: {
      fill: "#DDEFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320 196.53 326.52 196.69 328.89 191.19 330.26 191.57 327.39 200.19 318.5 204.78 320 196.53",
    style: {
      fill: "#DDEFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.13 203.28 290 202.66 290 201.28 289.73 201.22 289.3 201.76 288.25 199.91 286.96 200.91 287.75 203.66 289.13 203.28",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.89 191.19 328.01 190.57 328.01 189.19 328.28 189.14 328.71 189.67 329.76 187.82 331.06 188.82 330.26 191.57 328.89 191.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.08,
    y: 227.66,
    width: 2.71,
    height: 11.17,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.69,244.16l-13.25-2.75v-8.92h-4v8.92l-13.25,2.75v1.66l14.25-2.21V246h2v-2.38l14.25,2.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.85 228.32 299.98 228.32 298 202.66 318.83 202.66 316.85 228.32",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.5,
    y: 195.16,
    width: 6.83,
    height: 1.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-215"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 237.08,
    y: 191.91,
    width: 3.49,
    height: 5.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.4,
    y: 189.19,
    width: 1.41,
    height: 2.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.66,
    y: 189.19,
    width: 1.41,
    height: 2.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.72,195.65h0a3.13,3.13,0,0,1-3.13-3.13v-4.75a3.14,3.14,0,0,1,3.13-3.14h0a3.15,3.15,0,0,1,3.14,3.14v4.75A3.14,3.14,0,0,1,238.72,195.65Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.83 220.99 224.5 221.66 226.17 242.99 227.67 242.99 228.17 226.82 231.83 226.53 229.83 220.99",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.83 220.99 252.17 221.66 250.5 242.99 249 242.99 248.5 226.82 244.83 226.53 246.83 220.99",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.33 196.53 249.83 196.53 244.58 226.53 231.83 226.53 227.33 196.53",
    style: {
      fill: "#DDEFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.33 196.53 221.21 207.53 218.96 203.28 217.58 203.66 220.46 212.28 228.33 204.66 227.33 196.53",
    style: {
      fill: "#DDEFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.83 196.53 255.96 207.53 258.21 203.28 259.58 203.66 256.71 212.28 248.33 204.78 249.83 196.53",
    style: {
      fill: "#DDEFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.96 203.28 219.83 202.66 219.83 201.28 219.56 201.22 219.14 201.76 218.08 199.91 216.79 200.91 217.58 203.66 218.96 203.28",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.21 203.28 257.33 202.66 257.33 201.28 257.6 201.22 258.03 201.76 259.08 199.91 260.37 200.91 259.58 203.66 258.21 203.28",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.92,
    y: 227.66,
    width: 2.71,
    height: 11.17,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.52,244.16l-13.25-2.75v-8.92h-4v8.92L223,244.16v1.66l14.25-2.21V246h2v-2.38l14.25,2.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.69 228.32 229.81 228.32 227.83 202.66 248.67 202.66 246.69 228.32",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.33,
    y: 195.16,
    width: 6.83,
    height: 1.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-215"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.38,162v-5.11a3.31,3.31,0,0,1,2.43-3.21,9.91,9.91,0,0,1,1.88-.29,4.12,4.12,0,0,1,4.3,3c.5,1.32,0,8.44,0,8.44a1.86,1.86,0,0,1-2.32.5V167h-6.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,156.36a4.13,4.13,0,0,0-4.3-3,9.91,9.91,0,0,0-1.88.29,3.31,3.31,0,0,0-2.43,3.21V162l.07,2.14a4.27,4.27,0,0,0,2.08.67,5.15,5.15,0,0,0,4.47-1.65l-1.32-.83-.66-3,1.49-.33.49,2.15h.83l-.16-2.48h1Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.72,
    y: 166.62,
    width: 9.27,
    height: 2.32,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.78 183.84 163.58 177.22 166.06 190.47 178.81 190.47 180.63 178.22 188.58 180.53 194.71 164.97 193.05 164.47 187.26 174.57 180.8 168.44 162.75 168.44 154.97 182.85 161.92 195.6 163.41 195.1 158.78 183.84",
    style: {
      fill: "#DDEFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.06 190.47 165.56 197.09 160.76 242.96 162.59 242.96 172.19 200.74 173.35 200.74 183.94 242.3 186.1 242.3 179.47 195.77 178.81 190.47 166.06 190.47",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.05 164.47 195.37 158.18 196.2 158.34 195.87 160 197.85 160.99 197.03 163.97 196.03 163.97 194.71 164.97 193.05 164.47",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.41 195.1 165.07 198.77 163.58 199.59 161.92 195.6 163.41 195.1",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.1 242.3 189.94 244.98 184.1 244.98 183.94 242.3 186.1 242.3",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.67 242.3 156.84 244.98 162.67 244.98 162.83 242.3 160.67 242.3",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-215"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.61,302h68a0,0,0,0,1,0,0V363a0,0,0,0,1,0,0h-68a1.62,1.62,0,0,1-1.62-1.62v-57.8A1.62,1.62,0,0,1,280.61,302Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.82,
    y: 301.98,
    width: 70.13,
    height: 61.05,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.22,
    y: 306.82,
    width: 60.9,
    height: 51.38,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.86,
    y: 310.73,
    width: 17.42,
    height: 43.56,
    transform: "translate(599.13 665.02) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.86,
    y: 314.12,
    width: 51.63,
    height: 40.17,
    transform: "translate(633.34 668.42) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.54,
    y: 316.21,
    width: 46.26,
    height: 35.99,
    transform: "translate(633.34 668.42) rotate(180)",
    style: {
      fill: "#DDEFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.56,
    y1: 327.96,
    x2: 304.18,
    y2: 327.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.56,
    y1: 330.58,
    x2: 304.18,
    y2: 330.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.56,
    y1: 333.19,
    x2: 304.18,
    y2: 333.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.56,
    y1: 337.63,
    x2: 333.43,
    y2: 337.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.56,
    y1: 341.02,
    x2: 333.43,
    y2: 341.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.56,
    y1: 344.42,
    x2: 333.43,
    y2: 344.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.82 363.04 321.68 376.57 393.35 376.57 350.95 363.04 280.82 363.04",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.85 368.25 325.94 366.36 323.04 366.33 328.93 368.23 331.85 368.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.62 368.3 331.69 366.42 328.82 366.39 334.75 368.27 337.62 368.3",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.87 370.3 360.64 370.31 354.47 368.42 351.71 368.4 357.87 370.3",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.93 368.23 323.04 366.33 320.12 366.31 325.99 368.21 328.93 368.23",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.03 368.19 317.17 366.28 314.21 366.25 320.05 368.17 323.03 368.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.93 368.38 342.94 366.52 340.15 366.5 346.13 368.36 348.93 368.38",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.71 368.4 345.7 366.55 342.94 366.52 348.93 368.38 351.71 368.4",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.05 368.17 314.21 366.25 311.22 366.22 317.05 368.14 320.05 368.17",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.48 368.32 334.53 366.44 331.69 366.42 337.62 368.3 340.48 368.32",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.47 368.42 348.44 366.58 345.7 366.55 351.71 368.4 354.47 368.42",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.13 368.36 340.15 366.5 337.35 366.47 343.32 368.34 346.13 368.36",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.32 368.34 337.35 366.47 334.53 366.44 340.48 368.32 343.32 368.34",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.75 368.27 328.82 366.39 325.94 366.36 331.85 368.25 334.75 368.27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.02 368.12 310.97 368.1 316.92 370.09 319.98 370.11 314.02 368.12",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.21 366.19 305.19 366.16 310.97 368.1 314.02 368.12 308.21 366.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.05 368.14 311.22 366.22 308.21 366.19 314.02 368.12 317.05 368.14",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.01 372.13 329.28 374.23 332.38 374.23 326.1 372.14 323.01 372.13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.98 370.11 316.92 370.09 323.01 372.13 326.1 372.14 319.98 370.11",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.1 372.14 332.38 374.23 335.46 374.23 329.16 372.15 326.1 372.14",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.99 368.21 320.12 366.31 317.17 366.28 323.03 368.19 325.99 368.21",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.02 370.17 325.99 368.21 323.03 368.19 329.04 370.15 332.02 370.17",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.04 370.15 323.03 368.19 320.05 368.17 326.04 370.14 329.04 370.15",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.98 370.18 328.93 368.23 325.99 368.21 332.02 370.17 334.98 370.18",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.05 368.14 314.02 368.12 319.98 370.11 323.02 370.12 317.05 368.14",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.19 372.24 366.97 372.25 360.64 370.31 357.87 370.3 364.19 372.24",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.04 370.14 320.05 368.17 317.05 368.14 323.02 370.12 326.04 370.14",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.98 370.11 326.1 372.14 329.16 372.15 323.02 370.12 319.98 370.11",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.27 370.27 346.13 368.36 343.32 368.34 349.44 370.25 352.27 370.27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.44 370.25 343.32 368.34 340.48 368.32 346.58 370.24 349.44 370.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.87 370.3 351.71 368.4 348.93 368.38 355.08 370.28 357.87 370.3",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.82 370.21 334.75 368.27 331.85 368.25 337.91 370.19 340.82 370.21",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.58 370.24 340.48 368.32 337.62 368.3 343.71 370.22 346.58 370.24",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.71 370.22 337.62 368.3 334.75 368.27 340.82 370.21 343.71 370.22",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.91 370.19 331.85 368.25 328.93 368.23 334.98 370.18 337.91 370.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.58 370.24 352.85 372.21 355.71 372.22 349.44 370.25 346.58 370.24",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.44 370.25 355.71 372.22 358.56 372.23 352.27 370.27 349.44 370.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.02 370.12 329.16 372.15 332.2 372.16 326.04 370.14 323.02 370.12",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.27 370.27 358.56 372.23 361.38 372.23 355.08 370.28 352.27 370.27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.82 370.21 347.06 372.19 349.96 372.2 343.71 370.22 340.82 370.21",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.08 370.28 361.38 372.23 364.19 372.24 357.87 370.3 355.08 370.28",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.71 370.22 349.96 372.2 352.85 372.21 346.58 370.24 343.71 370.22",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.04 370.15 335.21 372.17 338.21 372.17 332.02 370.17 329.04 370.15",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.04 370.14 332.2 372.16 335.21 372.17 329.04 370.15 326.04 370.14",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.91 370.19 344.13 372.19 347.06 372.19 340.82 370.21 337.91 370.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.98 370.18 341.18 372.18 344.13 372.19 337.91 370.19 334.98 370.18",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.02 370.17 338.21 372.17 341.18 372.18 334.98 370.18 332.02 370.17",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.08 370.28 348.93 368.38 346.13 368.36 352.27 370.27 355.08 370.28",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.21 366.19 302.02 364.13 299.02 364.1 305.19 366.16 308.21 366.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.19 366.16 302.37 366.13 308.14 368.08 310.97 368.1 305.19 366.16",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.02 364.1 296.22 364.06 302.37 366.13 305.19 366.16 299.02 364.1",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.97 368.1 308.14 368.08 314.06 370.08 316.92 370.09 310.97 368.1",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.92 370.09 314.06 370.08 320.15 372.13 323.01 372.13 316.92 370.09",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.01 372.13 320.15 372.13 326.4 374.23 329.28 374.23 323.01 372.13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.2 368.44 363.39 370.32 365.81 370.33 359.61 368.46 357.2 368.44",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.73 372.25 372.16 372.26 365.81 370.33 363.39 370.32 369.73 372.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.24 374.23 378.68 374.23 372.16 372.26 369.73 372.25 376.24 374.23",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.69 366.42 325.35 364.41 322.5 364.38 328.82 366.39 331.69 366.42",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.2 368.44 359.61 368.46 353.57 366.63 351.17 366.6 357.2 368.44",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.97 372.25 369.73 372.25 363.39 370.32 360.64 370.31 366.97 372.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.22 366.22 305.01 364.17 302.02 364.13 308.21 366.19 311.22 366.22",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.44 366.58 354.47 368.42 357.2 368.44 351.17 366.6 348.44 366.58",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.57 366.63 347.11 364.67 344.73 364.64 351.17 366.6 353.57 366.63",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.17 366.6 344.73 364.64 342.01 364.61 348.44 366.58 351.17 366.6",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.56 372.23 365.01 374.23 367.85 374.23 361.38 372.23 358.56 372.23",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.46 374.23 376.24 374.23 369.73 372.25 366.97 372.25 373.46 374.23",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.44 366.58 342.01 364.61 339.28 364.58 345.7 366.55 348.44 366.58",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.19 372.24 370.67 374.23 373.46 374.23 366.97 372.25 364.19 372.24",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.38 372.23 367.85 374.23 370.67 374.23 364.19 372.24 361.38 372.23",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.64 370.31 363.39 370.32 357.2 368.44 354.47 368.42 360.64 370.31",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.04 366.33 316.76 364.31 313.85 364.27 320.12 366.31 323.04 366.33",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.7 366.55 339.28 364.58 336.54 364.54 342.94 366.52 345.7 366.55",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.12 366.31 313.85 364.27 310.93 364.24 317.17 366.28 320.12 366.31",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.82 366.39 322.5 364.38 319.64 364.34 325.94 366.36 328.82 366.39",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.17 366.28 310.93 364.24 307.98 364.2 314.21 366.25 317.17 366.28",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.21 366.25 307.98 364.2 305.01 364.17 311.22 366.22 314.21 366.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.94 366.36 319.64 364.34 316.76 364.31 323.04 366.33 325.94 366.36",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.94 366.52 336.54 364.54 333.77 364.51 340.15 366.5 342.94 366.52",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.15 366.5 333.77 364.51 330.98 364.48 337.35 366.47 340.15 366.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.53 366.44 328.18 364.44 325.35 364.41 331.69 366.42 334.53 366.44",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.56 372.23 355.71 372.22 352.85 372.21 349.96 372.2 347.06 372.19 344.13 372.19 341.18 372.18 338.21 372.17 335.21 372.17 332.2 372.16 329.16 372.15 335.46 374.23 338.52 374.23 341.55 374.23 344.56 374.23 347.55 374.23 350.51 374.23 353.45 374.23 356.38 374.23 359.27 374.23 362.15 374.23 365.01 374.23 358.56 372.23",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.35 366.47 330.98 364.48 328.18 364.44 334.53 366.44 337.35 366.47",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.82 363.04 280.82 365.08 321.66 379.18 321.68 376.57 280.82 363.04",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.68,
    y: 376.57,
    width: 71.67,
    height: 2.61,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.91 279.41 317.57 303.3 333.24 279.41 326.68 279.41 326.68 249.95 308.46 249.95 308.46 279.41 301.91 279.41",
    style: {
      fill: "#DDEFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-215"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.88,302h68a0,0,0,0,1,0,0V363a0,0,0,0,1,0,0h-68a1.62,1.62,0,0,1-1.62-1.62v-57.8A1.62,1.62,0,0,1,161.88,302Z",
    transform: "translate(390.14 665.02) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.92,
    y: 301.98,
    width: 70.13,
    height: 61.05,
    transform: "translate(385.96 665.02) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.75,
    y: 306.82,
    width: 60.9,
    height: 51.38,
    transform: "translate(384.39 665.02) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.38,
    y: 310.73,
    width: 17.42,
    height: 43.56,
    transform: "translate(350.18 665.02) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.38,
    y: 314.12,
    width: 51.63,
    height: 40.17,
    transform: "translate(384.39 668.42) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.07,
    y: 316.21,
    width: 46.26,
    height: 35.99,
    transform: "translate(384.39 668.42) rotate(180)",
    style: {
      fill: "#DDEFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.09,
    y1: 327.96,
    x2: 179.7,
    y2: 327.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.09,
    y1: 330.58,
    x2: 179.7,
    y2: 330.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.09,
    y1: 333.19,
    x2: 179.7,
    y2: 333.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.09,
    y1: 337.63,
    x2: 208.95,
    y2: 337.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.09,
    y1: 341.02,
    x2: 208.95,
    y2: 341.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.09,
    y1: 344.42,
    x2: 208.95,
    y2: 344.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.04 363.04 187.19 376.57 115.52 376.57 157.92 363.04 228.04 363.04",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.02 368.25 182.92 366.36 185.83 366.33 179.94 368.23 177.02 368.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.24 368.3 177.18 366.42 180.04 366.39 174.12 368.27 171.24 368.3",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151 370.3 148.23 370.31 154.4 368.42 157.16 368.4 151 370.3",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.94 368.23 185.83 366.33 188.75 366.31 182.87 368.21 179.94 368.23",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.84 368.19 191.69 366.28 194.66 366.25 188.82 368.17 185.84 368.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.94 368.38 165.93 366.52 168.72 366.5 162.73 368.36 159.94 368.38",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.16 368.4 163.17 366.55 165.93 366.52 159.94 368.38 157.16 368.4",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.82 368.17 194.66 366.25 197.64 366.22 191.82 368.14 188.82 368.17",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.39 368.32 174.34 366.44 177.18 366.42 171.24 368.3 168.39 368.32",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.4 368.42 160.42 366.58 163.17 366.55 157.16 368.4 154.4 368.42",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.73 368.36 168.72 366.5 171.52 366.47 165.55 368.34 162.73 368.36",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.55 368.34 171.52 366.47 174.34 366.44 168.39 368.32 165.55 368.34",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.12 368.27 180.04 366.39 182.92 366.36 177.02 368.25 174.12 368.27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.84 368.12 197.89 368.1 191.95 370.09 188.89 370.11 194.84 368.12",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.65 366.19 203.68 366.16 197.89 368.1 194.84 368.12 200.65 366.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.82 368.14 197.64 366.22 200.65 366.19 194.84 368.12 191.82 368.14",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.85 372.13 179.59 374.23 176.48 374.23 182.77 372.14 185.85 372.13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.89 370.11 191.95 370.09 185.85 372.13 182.77 372.14 188.89 370.11",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.77 372.14 176.48 374.23 173.41 374.23 179.71 372.15 182.77 372.14",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.87 368.21 188.75 366.31 191.69 366.28 185.84 368.19 182.87 368.21",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.85 370.17 182.87 368.21 185.84 368.19 179.82 370.15 176.85 370.17",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.82 370.15 185.84 368.19 188.82 368.17 182.82 370.14 179.82 370.15",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.89 370.18 179.94 368.23 182.87 368.21 176.85 370.17 173.89 370.18",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.82 368.14 194.84 368.12 188.89 370.11 185.84 370.12 191.82 368.14",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.68 372.24 141.9 372.25 148.23 370.31 151 370.3 144.68 372.24",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.82 370.14 188.82 368.17 191.82 368.14 185.84 370.12 182.82 370.14",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.89 370.11 182.77 372.14 179.71 372.15 185.84 370.12 188.89 370.11",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.6 370.27 162.73 368.36 165.55 368.34 159.43 370.25 156.6 370.27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.43 370.25 165.55 368.34 168.39 368.32 162.28 370.24 159.43 370.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151 370.3 157.16 368.4 159.94 368.38 153.79 370.28 151 370.3",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.04 370.21 174.12 368.27 177.02 368.25 170.96 370.19 168.04 370.21",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.28 370.24 168.39 368.32 171.24 368.3 165.15 370.22 162.28 370.24",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.15 370.22 171.24 368.3 174.12 368.27 168.04 370.21 165.15 370.22",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.96 370.19 177.02 368.25 179.94 368.23 173.89 370.18 170.96 370.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.28 370.24 156.02 372.21 153.15 372.22 159.43 370.25 162.28 370.24",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.43 370.25 153.15 372.22 150.31 372.23 156.6 370.27 159.43 370.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.84 370.12 179.71 372.15 176.67 372.16 182.82 370.14 185.84 370.12",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.6 370.27 150.31 372.23 147.49 372.23 153.79 370.28 156.6 370.27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.04 370.21 161.81 372.19 158.9 372.2 165.15 370.22 168.04 370.21",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.79 370.28 147.49 372.23 144.68 372.24 151 370.3 153.79 370.28",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.15 370.22 158.9 372.2 156.02 372.21 162.28 370.24 165.15 370.22",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.82 370.15 173.65 372.17 170.66 372.17 176.85 370.17 179.82 370.15",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.82 370.14 176.67 372.16 173.65 372.17 179.82 370.15 182.82 370.14",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.96 370.19 164.74 372.19 161.81 372.19 168.04 370.21 170.96 370.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.89 370.18 167.69 372.18 164.74 372.19 170.96 370.19 173.89 370.18",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.85 370.17 170.66 372.17 167.69 372.18 173.89 370.18 176.85 370.17",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.79 370.28 159.94 368.38 162.73 368.36 156.6 370.27 153.79 370.28",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.65 366.19 206.84 364.13 209.85 364.1 203.68 366.16 200.65 366.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.68 366.16 206.5 366.13 200.73 368.08 197.89 368.1 203.68 366.16",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.85 364.1 212.65 364.06 206.5 366.13 203.68 366.16 209.85 364.1",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.89 368.1 200.73 368.08 194.8 370.08 191.95 370.09 197.89 368.1",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.95 370.09 194.8 370.08 188.72 372.13 185.85 372.13 191.95 370.09",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.85 372.13 188.72 372.13 182.47 374.23 179.59 374.23 185.85 372.13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.66 368.44 145.48 370.32 143.06 370.33 149.25 368.46 151.66 368.44",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.13 372.25 136.71 372.26 143.06 370.33 145.48 370.32 139.13 372.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.63 374.23 130.19 374.23 136.71 372.26 139.13 372.25 132.63 374.23",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.18 366.42 183.52 364.41 186.36 364.38 180.04 366.39 177.18 366.42",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.66 368.44 149.25 368.46 155.3 366.63 157.7 366.6 151.66 368.44",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.9 372.25 139.13 372.25 145.48 370.32 148.23 370.31 141.9 372.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.64 366.22 203.85 364.17 206.84 364.13 200.65 366.19 197.64 366.22",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.42 366.58 154.4 368.42 151.66 368.44 157.7 366.6 160.42 366.58",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.3 366.63 161.76 364.67 164.14 364.64 157.7 366.6 155.3 366.63",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.7 366.6 164.14 364.64 166.85 364.61 160.42 366.58 157.7 366.6",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.31 372.23 143.85 374.23 141.02 374.23 147.49 372.23 150.31 372.23",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.41 374.23 132.63 374.23 139.13 372.25 141.9 372.25 135.41 374.23",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.42 366.58 166.85 364.61 169.58 364.58 163.17 366.55 160.42 366.58",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.68 372.24 138.2 374.23 135.41 374.23 141.9 372.25 144.68 372.24",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.49 372.23 141.02 374.23 138.2 374.23 144.68 372.24 147.49 372.23",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.23 370.31 145.48 370.32 151.66 368.44 154.4 368.42 148.23 370.31",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.83 366.33 192.11 364.31 195.02 364.27 188.75 366.31 185.83 366.33",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.17 366.55 169.58 364.58 172.33 364.54 165.93 366.52 163.17 366.55",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.75 366.31 195.02 364.27 197.94 364.24 191.69 366.28 188.75 366.31",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.04 366.39 186.36 364.38 189.23 364.34 182.92 366.36 180.04 366.39",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.69 366.28 197.94 364.24 200.89 364.2 194.66 366.25 191.69 366.28",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.66 366.25 200.89 364.2 203.85 364.17 197.64 366.22 194.66 366.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.92 366.36 189.23 364.34 192.11 364.31 185.83 366.33 182.92 366.36",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.93 366.52 172.33 364.54 175.1 364.51 168.72 366.5 165.93 366.52",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.72 366.5 175.1 364.51 177.89 364.48 171.52 366.47 168.72 366.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.34 366.44 180.69 364.44 183.52 364.41 177.18 366.42 174.34 366.44",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.31 372.23 153.15 372.22 156.02 372.21 158.9 372.2 161.81 372.19 164.74 372.19 167.69 372.18 170.66 372.17 173.65 372.17 176.67 372.16 179.71 372.15 173.41 374.23 170.35 374.23 167.32 374.23 164.31 374.23 161.32 374.23 158.36 374.23 155.41 374.23 152.49 374.23 149.59 374.23 146.71 374.23 143.85 374.23 150.31 372.23",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.52 366.47 177.89 364.48 180.69 364.44 174.34 366.44 171.52 366.47",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.04 363.04 228.04 365.08 187.2 379.18 187.19 376.57 228.04 363.04",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.52,
    y: 376.57,
    width: 71.67,
    height: 2.61,
    transform: "translate(302.71 755.75) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.46 266.51 195.8 242.62 180.13 266.51 186.69 266.51 186.69 302.64 204.91 302.64 204.91 266.51 211.46 266.51",
    style: {
      fill: "#DDEFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudMigration);
export default __webpack_public_path__ + "static/media/CloudMigration.a6d4797df4a33c0bbd5b3bd32c2a1ba8.svg";
export { ForwardRef as ReactComponent };